import type { AdminCliCommand, AdminCliCommandsResponse } from '@brand24-original/llm-types';
import { client } from '../../apiClient';

export const getCliCommands = async (): Promise<AdminCliCommand[]> =>
  client(true, true)
    .get<AdminCliCommandsResponse>('/admin/cli-commands')
    .then((response) => response.data.commands);
